import React, { useMemo, useState } from "react";
import TopFilter from "./TopFilter";
import StudentsTable from "./StudentsTable";
import { useGetAllStudentProgressQuery } from "../../services/student-progress/studentProgressApi";

const StudentProgressView = () => {
  const [selectedPlan, setSelectedPlan] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const { data: response } = useGetAllStudentProgressQuery();
  const courseOptions = useMemo(() => {
    const courses = [
      ...new Set(
        (response?.data ?? [])
          .map((student) => student.courseTitle)
          .filter(Boolean),
      ),
    ];

    return [
      { label: "Filter by course", value: "" },
      ...courses.map((course) => ({ label: course, value: course })),
    ];
  }, [response?.data]);

  return (
    <section className="min-h-screen font-['Roboto'] bg-[#F5F5F5] px-5 xl:px-7 2xl:pl-14 pt-7 pb-10 2xl:pr-5">
      <TopFilter
        selectedPlan={selectedPlan}
        selectedCourse={selectedCourse}
        onPlanChange={setSelectedPlan}
        onCourseChange={setSelectedCourse}
        courseOptions={courseOptions}
      />

      <StudentsTable selectedPlan={selectedPlan} selectedCourse={selectedCourse} />
    </section>
  );
};

export default StudentProgressView;
